import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=a967aa66&scoped=true&"
import script from "./LoadingDots.vue?vue&type=script&lang=js&"
export * from "./LoadingDots.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDots.vue?vue&type=style&index=0&id=a967aa66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a967aa66",
  null
  
)

export default component.exports